"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ResourceFilterableCollection_1 = require("../DataModel/Collections/ResourceFilterableCollection");
const TypesCollection_1 = require("../DataModel/Collections/TypesCollection");
const namespaces_1 = require("../namespaces");
function rdfSchema(mappings) {
    mappings[namespaces_1.rdfs.range] = {
        default: ranges => new ResourceFilterableCollection_1.default(ranges.map(type => (typeof type === "string" ? { iri: type, type: TypesCollection_1.default.empty } : type))),
        propertyName: "valuesOfType",
        required: true,
        type: [namespaces_1.rdf.Property]
    };
    mappings[namespaces_1.rdfs.label] = {
        default: "",
        propertyName: "displayName",
        required: true,
        type: [namespaces_1.rdf.Property]
    };
    mappings[namespaces_1.rdfs.comment] = {
        default: "",
        propertyName: "description",
        required: true,
        type: [namespaces_1.rdf.Property]
    };
    return mappings;
}
exports.rdfSchema = rdfSchema;
//# sourceMappingURL=rdfSchema.js.map